
<script context="module">

import { 
  VmDailymotion,
  VmEmbed 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-dailymotion', VmDailymotion);
define('vm-embed', VmEmbed);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className;

export let style;
export { className as class };

export let videoId;
export let shouldAutoplayQueue = false;
export let showUpNextQueue = false;
export let showShareButtons = false;
export let color = undefined;
export let syndication = undefined;
export let showDailymotionLogo = false;
export let showVideoInfo = true;
export let language = 'en';
export let autoplay = false;
export let controls = false;
export let poster = undefined;
export let logger = undefined;
export let loop = false;
export let muted = false;
export let playsinline = false;
export const getAdapter = (...args) => __ref.getAdapter(...args);
export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => { 
  

  __mounted = true; 
});

$: if (__mounted) setProp(__ref, 'logger', logger);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-dailymotion 
  class={className}
  style={style}
  video-id={videoId}
  should-autoplay-queue={shouldAutoplayQueue}
  show-up-next-queue={showUpNextQueue}
  show-share-buttons={showShareButtons}
  color={color}
  syndication={syndication}
  show-dailymotion-logo={showDailymotionLogo}
  show-video-info={showVideoInfo}
  language={language}
  autoplay={autoplay}
  controls={controls}
  poster={poster}
  loop={loop}
  muted={muted}
  playsinline={playsinline}
  on:vmLoadStart={onEvent}
  on:vmError={onEvent}
  bind:this={__ref}
>
  <slot></slot>
</vm-dailymotion>
  